jQuery(function($){
  if($('.tooltip').length>0){
    new jBox('Tooltip', {
    attach: '.tooltip',
      maxWidth: 300,
      theme: 'TooltipDark'
  });
  }

  if($('.tooltip-html').length>0){
    new jBox('Tooltip', {
    attach: '.tooltip-html',
      maxWidth: 500,
      isolateScroll: true,
      getTitle: 'data-title',
      getContent: 'data-content',
      theme: 'TooltipDark'
  });
  }

  if($('#jw_chat').length>0){
    $("#jw_chat").click(function(event) {
        event.preventDefault(); // Prevents default behavior of the <a> tag
        //$("#chat-button").trigger("click");
        //console.log();
      GorgiasChat.open();
      });
   }


 
    if($('.jw_home_logo_main_carousel').length>0){
      $('.jw_home_logo_main_carousel').slick({
        centerPadding: '60px',
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,   
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              centerPadding: '40px',
              slidesToShow: 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3
            }
          },
           {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
   }


  if($('#jw_pregnacy_due_date_target').length >0){
     // Initialize datepicker
        $("#jw_pregnacy_due_date_target #lastPeriod").datepicker({
            dateFormat: 'dd/mm/yy',
            changeMonth: true,
            changeYear: true,
            onSelect: function(){
              $("#jw_pregnacy_due_date_target #result").html("");
            }
        });

        $("#jw_pregnacy_due_date_target #calculateBtn").click(function () {
            var lastPeriod = $("#lastPeriod").val();
            var dueDate = calculateDueDate(lastPeriod);
            $("#jw_pregnacy_due_date_target #result").html("<strong>Your due date is:</strong> " + dueDate);
        });

        function calculateDueDate(lastPeriod) {
            // Assuming a gestation period of 280 days (40 weeks)
            var gestationPeriod = 280;
            var lastPeriodDate = $.datepicker.parseDate('dd/mm/yy', lastPeriod);
            var dueDate = new Date(lastPeriodDate.getTime() + gestationPeriod * 24 * 60 * 60 * 1000);

            // Format the due date
            var options = { year: 'numeric', month: 'long', day: 'numeric' };
            return dueDate.toLocaleDateString('en-US', options);
        }
  }

 if($('#jw_ovulation_date_target').length >0){
    // Initialize datepicker
        $("#jw_ovulation_date_target .datepicker").datepicker({
            dateFormat: 'dd/mm/yy',
            changeMonth: true,
            changeYear: true,
            onSelect: function(){
              $("#jw_ovulation_date_target #result").html("");
            }
        });

         // Handle button click
        $("#calculateBtn").click(function () {
            var firstDayOfLastPeriod = $("#jw_ovulation_date_target #firstDayOfLastPeriod").val();
            var cycleLength = $("#jw_ovulation_date_target #cycleLength").val();
            var resultSection = $("#jw_ovulation_date_target #result");

            // Clear previous results
            resultSection.empty();

            // Validate input
            if (!firstDayOfLastPeriod || !cycleLength) {
                resultSection.html("Please enter both the first day of the last period and the average cycle length.");
                return;
            }

            // Parse input values
            var lastPeriodDate = $.datepicker.parseDate('dd/mm/yy', firstDayOfLastPeriod);
            if (!lastPeriodDate) {
                resultSection.html("Invalid date format for the first day of the last period.");
                return;
            }

            // Calculate ovulation date
            var ovulationDate = new Date(lastPeriodDate.getTime() + (cycleLength - 14) * 24 * 60 * 60 * 1000);

            // Format the ovulation date
            var options = { year: 'numeric', month: 'long', day: 'numeric' };
            var formattedDate = ovulationDate.toLocaleDateString('en-US', options);

            // Display result
            resultSection.html("<strong>Estimated Ovulation Date:</strong> " + formattedDate);
        });
    
 }

   if($('#jw_recipes_section').length >0){
     $('.popup-video').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: false
	});
   }
  
  
});